import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { url_servicios } from 'src/app/config/config';
import { NoteBcbaV2 } from '../models';
import { ApiService } from './api.service';

type NoteBcbaDetailsResponse = {
  rbt_training_goals: unknown;
  caregiver_goals: unknown;
  noteBcba: NoteBcbaV2;
};

type GenerateAiSummaryResponse = {
  summary: string;
  [key: string]: unknown;
};

@Injectable({
  providedIn: 'root',
})
export class NoteBcbaService extends ApiService<NoteBcbaV2> {
  constructor() {
    super(inject(HttpClient), url_servicios + '/note_bcba');
  }

  getNote(id: number): Observable<NoteBcbaDetailsResponse> {
    return this.get(id) as unknown as Observable<NoteBcbaDetailsResponse>;
  }

  showNotebyPatient(patient_id: number | string): Observable<unknown> {
    const URL = url_servicios + '/note_bcba/byprofile/' + patient_id;
    return this.http.get<unknown>(URL);
  }
  showReplacementbyPatient(patient_id: number | string): Observable<unknown> {
    const URL =
      url_servicios + '/note_bcba/showReplacementBypatient/' + patient_id;
    return this.http.get<unknown>(URL);
  }
  showNotebyClient(client_id: number | string): Observable<unknown> {
    const URL = url_servicios + '/note_bcba/byclient/' + client_id;
    return this.http.get<unknown>(URL);
  }

  listConfigNote(): Observable<unknown> {
    const URL = url_servicios + '/note_bcba/config';
    return this.http.get<unknown>(URL);
  }

  updateStatus(data: Record<string, unknown>, client_id: number | string): Observable<unknown> {
    const URL = url_servicios + '/note_bcba/update/status/' + client_id;
    return this.http.put<unknown>(URL, data);
  }

  noteBCBAUpdateModifier(data: Record<string, unknown>, client_id: number | string): Observable<unknown> {
    const URL = url_servicios + '/note_bcba/update/modifier/' + client_id;
    return this.http.put<unknown>(URL, data);
  }

  generateAISummary(data: Record<string, unknown>): Observable<GenerateAiSummaryResponse> {
    const URL = url_servicios + '/note_bcba/generate-summary';
    return this.http.post<GenerateAiSummaryResponse>(URL, data);
  }

  getPdf(note_id: number) {
    const URL = url_servicios + '/v2/note_bcba/pdf/' + note_id;
    return this.http.get(URL, { responseType: 'arraybuffer' });
  }
}
